const filtersEndPoint = "/tennis/api/TournamentApi/GetOrderOfPlayDays";
const oopEndPoint = "/tennis/api/TournamentApi/GetOrderOfPlay";

export async function getOop(orderOfPlayDayId: number) {
  const response = await fetch(
    `${process.env.HOST}${oopEndPoint}?orderOfPlayDayId=${orderOfPlayDayId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
      cache: "no-cache"
    }
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getFilters(tournamentKey: string) {
  const response = await fetch(
    `${process.env.HOST}${filtersEndPoint}?tournamentKey=${tournamentKey}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
      cache: "no-cache"
    }
  );

  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
